import { useAuth } from 'react-oidc-context';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Dashboard } from './dashboard/Dashboard';
import { Deals } from './deals/Deals';
import { Customers } from './customers/Customers';
import { NotFound } from './not-found/NotFound';
import { NewDeal } from './deals/new/NewDeal';
import { NewCustomer } from './customers/new/NewCustomer';
import { DealDetail } from './deals/detail/DealDetail';
import { EditCustomer } from './customers/edit/EditCustomer';
import ClassificationPage from './classification/ClassificationPage';
import FeaturesList from './classification/features/FeatureList';
import { GroupPage } from './classification/groups/GroupPage';
import { GroupDetail } from './classification/groups/detail/GroupDetail';
import { ObjectDetail } from './classification/objects/ObjectDetail';
import GroupObjectList from './classification/objects/GroupObjectList';

export function RouteConfig() {
  const auth = useAuth();

  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="deals" element={<Outlet />}>
        <Route index element={<Deals />} />
        <Route path=":id" element={<DealDetail />} />
        <Route path=":id/:calculationId" element={<DealDetail />} />
        <Route path="new" element={<NewDeal />} />
      </Route>
      <Route path="customers" element={<Outlet />}>
        <Route index element={<Customers />} />
        <Route path=":id" element={<EditCustomer />} />
        <Route path="new" element={<NewCustomer />} />
      </Route>
      <Route path="classification" element={<ClassificationPage />}>
        <Route path="features" element={<FeaturesList />} />
        <Route path="groups" element={<GroupPage />}>
          <Route path=":id" element={<GroupDetail />} />
          <Route path="objects" element={<GroupObjectList />} />
        </Route>
        <Route path="objects" element={<ObjectDetail />} />
      </Route>
      <Route
        path="/"
        element={auth.isAuthenticated ? <Navigate to="dashboard" replace={true} /> : <></>}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export enum RoutePaths {
  CLASSIFICATION = '/classification',
  CLASSIFICATION_FEATURES = '/classification/features',
  CLASSIFICATION_GROUPS = '/classification/groups',
  CLASSIFICATION_OBJECTS = '/classification/objects',
  CLASSIFICATION_OBJECTGROUPS = '/classification/groups/objects',
}
